(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    function raawSyncSizeAvailability(event) {
  const form = event.target.closest('form[data-raaw-clothing-filters]');
  if (!form) return;
  const availability = form.querySelector('[data-raaw-size-availability]');
  const sizes = Array.from(form.querySelectorAll('input[type="checkbox"]')).filter(input => input.name === 'filter.v.option.size' || input.name === 'filter.v.option.størrelse');
  if (availability) availability.disabled = !sizes.some(input => input.checked);
}
document.addEventListener('input', raawSyncSizeAvailability, true);
document.addEventListener('change', raawSyncSizeAvailability, true);
document.addEventListener('click', event => {
  const link = event.target.closest('.active-facets a');
  if (!link || !document.querySelector('form[data-raaw-clothing-filters]')) return;
  const url = new URL(link.href);
  const hasSize = url.searchParams.has('filter.v.option.size') || url.searchParams.has('filter.v.option.størrelse');
  if (hasSize) url.searchParams.set('filter.v.availability', '1');
  else url.searchParams.delete('filter.v.availability');
  link.href = url.href;
}, true);
  } catch(e) { console.error(e); }
})();

})();
